// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2p0Nu","imageUploader":"EGiftCard_imageUploader__228GG"};